import { Module } from 'vuex'

export type FreeSpaceState = {
  sourceCode: string
  isErrorShow: boolean
  testInput: string
  userOutput: string
  errorMessage: string
}

export const freeSpaceStateModule = (): Module<FreeSpaceState, any> => {
  return {
    namespaced: true,
    state: {
      sourceCode: '',
      isErrorShow: true,
      testInput: '',
      userOutput: '',
      errorMessage: ''
    },
    mutations: {
      setSourceCode(state, { code }: { code: string }) {
        state.sourceCode = code
      },
      setIsErrorShow(state, { isErrorShow }: { isErrorShow: boolean }) {
        state.isErrorShow = isErrorShow
      },
      setTestInput(state, { input }: { input: string }) {
        state.testInput = input
      },
      setOutput(state, { output }: { output: string }) {
        state.userOutput = output
      },
      setErrorMessage(state, { errorMessage }: { errorMessage: string }) {
        state.errorMessage = errorMessage
      }
    },
    actions: {},
    getters: {
      sourceCode: state => state.sourceCode,
      isErrorShow: state => state.isErrorShow,
      testInput: state => state.testInput,
      userOutput: state => state.userOutput,
      errorMessage: state => state.errorMessage
    }
  }
}
